import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { Flex, Input, Select, Typography } from 'antd'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {  addAbonementClubItem, getAbonementListClubItems, getAbonementTypes } from 'src/store/Slices/AbonementsSlice'
import { openNotification } from 'src/components/helpers/notification';

const AddNewAbonementServices = ({ visible, setVisible, abonementCostInfo }) => {

    // HELPERS
    const dispatch = useDispatch()

    // STATE
    const [name, setName] = useState()
    const [service, setService] = useState()
    const [serviceCount, setServiceCount] = useState()

    const abonementServices = useSelector(state => state.AbonementsSlice.abonementServices)


    useEffect(() => {
        dispatch(getAbonementTypes())
    }, [])

    useEffect(() => {
        setName('')
        setService('')
        setServiceCount(0)
    }, [visible])

    const onClickAddAbonement = () => {
        dispatch(addAbonementClubItem({
            abonementClubId : abonementCostInfo.id,
            itemName : name,
            serviceId : service,
            serviceCount : serviceCount,
        })).then(() => {
            dispatch(getAbonementListClubItems({ AbonementClubId: abonementCostInfo.id }))
            setVisible(false)
        })
    }

    return (
        <CModal
            alignment="center"
            visible={visible}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible(false) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    'Добавить состав пакета'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>Наименование</Typography.Title>
                            <Input
                                defaultValue=""
                                value={name}
                                onChange={e => setName(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Услуги</Typography.Title>
                            <Select
                                style={{ width: '100%' }}
                                options={abonementServices?.data.value}
                                placeholder={'Выбрать'}
                                value={service}
                                onChange={e => setService(e)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Кол-во тренировок</Typography.Title>
                            <Input
                                defaultValue=""
                                type='number'
                                value={serviceCount}
                                onChange={e => setServiceCount(e.currentTarget.value)}
                            />
                        </div>

                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible(false) }}
                    style={{ color: '#fff' }}
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton onClick={onClickAddAbonement} style={{ color: '#fff' }}>
                    Добавить
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default AddNewAbonementServices